import { render, staticRenderFns } from "./SessionsLayout.vue?vue&type=template&id=87ae41c6&lang=pug&"
import script from "./SessionsLayout.vue?vue&type=script&lang=js&"
export * from "./SessionsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports